import NotFound from "@/routes/@errors/404";
import App from "@/routes/app";
import * as Sentry from "@sentry/react";
import { createBrowserRouter } from "react-router-dom";

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

export const appRouter = sentryCreateBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);
